import React from "react";
import { useState } from "react";
import {
  errorToastNotif,
  getDataFromLocalStorage,
  nullConverter,
  successToastNotif,
} from "utils/common";
import { useFormik } from "formik";
import { PageMode, YesAndNoOptions } from "utils/constant";
import DataDasarWilker from "services/DataDasarWilker";
import BKK from "services/BKK";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { BreadcrumbNav } from "components/molecules";
import InputDate from "components/atoms/InputDate";
import moment from "moment";
import InputSelect from "components/atoms/InputSelect";
import Button from "components/atoms/Button";
import MapsComponents from "components/Maps/OpenStreetMap";
import InputField from "components/atoms/InputField";

const BKKService = new BKK();
const DataDasarWilkerService = new DataDasarWilker();

const FormComponent = ({ changeMode, pageMode }) => {
  const [WilkerData, setWilkerData] = useState([]);
  const [itemToEdit, setItemToEdit] = useState(null);

  const { currentUser } = useSelector((state) => state.authReducer);

  const formik = useFormik({
    initialValues: {
      year: "",
      is_faskes_malaria_service: "",
      is_faskes_malaria_medicine_service: "",
      bkk_id: "",
      address: "",
      coordinate: "",
    },
    validate: (values) => {
      const errors = {};

      if (!values.year) {
        errors.year = "Tahun wajib diisi";
      }

      if (!values.is_faskes_malaria_service) {
        errors.is_faskes_malaria_service =
          "Wilker pemberi layanan malaria wajib diisi";
      }

      if (!values.is_faskes_malaria_medicine_service) {
        errors.is_faskes_malaria_medicine_service =
          "Wilker rujukan obat malaria wajib diisi";
      }

      if (!values.bkk_id) {
        errors.bkk_id = "Wilker wajib diisi";
      }

      return errors;
    },

    onSubmit: async (values) => {
      let payload = {
        year: nullConverter(values.year),
        is_faskes_malaria_service: nullConverter(
          values.is_faskes_malaria_service
        ),
        is_faskes_malaria_medicine_service: nullConverter(
          values.is_faskes_malaria_medicine_service
        ),
        bkk_id: nullConverter(values.bkk_id),
        address: nullConverter(values.address),
        coordinate: nullConverter(values.coordinate),
      };
      switch (pageMode) {
        case PageMode.add:
          await DataDasarWilkerService.add(payload)
            .then((res) => {
              changeMode(PageMode.view);
              successToastNotif("Data Dasar Wilker Berhasil Ditambahkan");
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
        case PageMode.edit:
          await DataDasarWilkerService.update(payload, itemToEdit?.id)
            .then((res) => {
              changeMode(PageMode.view);
              successToastNotif("Data Dasar Wilker Berhasil Diupdate");
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
      }
    },
  });

  const fetchWilkerData = async () => {
    try {
      const response = await BKKService.getAll({
        searchBy: "induk_id",
        searchValue: currentUser?.username,
        limit: 9999,
        page: 1,
        excludePkm: false,
      });

      const mappedData = response.bkk.map((item) => {
        return {
          label: item.name,
          value: `${item.id}|${item.name}`,
        };
      });

      setWilkerData(mappedData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleMapChange = (address, coordinate) => {
    const coordinateValue = Object.values(coordinate).toString();
    formik.setFieldValue("coordinate", coordinateValue);
  };

  useEffect(() => {
    fetchWilkerData();
  }, []);

  useEffect(() => {
    if (pageMode === PageMode.edit) {
      const selectedItem = getDataFromLocalStorage("SELECTED_ITEM");
      const parsedData =
        typeof selectedItem === "string"
          ? JSON.parse(selectedItem)
          : selectedItem;
      setItemToEdit(parsedData);

      formik.setValues({
        ...formik.initialValues,
        ...parsedData,
      });
    }
  }, []);

  return (
    <>
      <BreadcrumbNav
        items={[
          { label: "Data Dasar Faskes", link: "/data-dasar-faskes" },
          {
            label:
              pageMode === PageMode.add
                ? "Tambah Data Data Dasar Wilker"
                : "Edit Data Data Dasar Wilker",
            link: "#",
          },
        ]}
      />

      <h1 className="page-title">
        {pageMode === PageMode.add
          ? "Tambah Data Data Dasar Wilker"
          : "Edit Data Data Dasar Wilker"}
      </h1>

      <div className="form-grouping">
        <p
          className="warning"
          style={{ marginTop: "24px", marginBottom: "24px" }}
        >
          NOTE<span>*(WAJIB DIISI)</span>
        </p>

        <InputDate
          label={"Tahun"}
          name={"year"}
          placeholder={"Pilih Tahun"}
          dateFormat={"YYYY"}
          onChange={(e) => {
            const selectedYear = moment(e).format("YYYY");
            formik.handleChange("year")(selectedYear);
          }}
          onBlur={formik.handleBlur}
          value={formik.values.year}
          error={formik.errors.year && formik.touched.year}
          errorMessage={formik.errors.year}
          isRequired={true}
        />

        <InputSelect
          label={"Pilih Wilker"}
          name={"bkk_id"}
          placeholder={"Pilih Wilker"}
          data={WilkerData}
          onChange={(e) => {
            const selectedValue = e ? e.value : "";
            formik.handleChange("bkk_id")(selectedValue);
          }}
          onBlur={formik.handleBlur}
          value={WilkerData?.find(
            (item) => item.value === formik.values.bkk_id
          )}
          error={formik.errors.bkk_id && formik.touched.bkk_id}
          errorMessage={formik.errors.bkk_id}
          isRequired={true}
          isDisabled={pageMode === PageMode.edit}
        />

        <InputSelect
          label={"Wilker Pemberi Layanan Malaria?"}
          name={"is_faskes_malaria_service"}
          placeholder={"Pilih"}
          data={YesAndNoOptions}
          onChange={(e) => {
            const selectedValue = e ? e.value : "";
            formik.handleChange("is_faskes_malaria_service")(selectedValue);
          }}
          onBlur={formik.handleBlur}
          value={YesAndNoOptions?.find(
            (item) => item.value === formik.values.is_faskes_malaria_service
          )}
          error={
            formik.errors.is_faskes_malaria_service &&
            formik.touched.is_faskes_malaria_service
          }
          errorMessage={formik.errors.is_faskes_malaria_service}
          isRequired={true}
        />

        <InputSelect
          label={"Wilker Rujukan Obat Malaria?"}
          name={"is_faskes_malaria_medicine_service"}
          placeholder={"Pilih"}
          data={YesAndNoOptions}
          onChange={(e) => {
            const selectedValue = e ? e.value : "";
            formik.handleChange("is_faskes_malaria_medicine_service")(
              selectedValue
            );
          }}
          onBlur={formik.handleBlur}
          value={YesAndNoOptions?.find(
            (item) =>
              item.value === formik.values.is_faskes_malaria_medicine_service
          )}
          error={
            formik.errors.is_faskes_malaria_medicine_service &&
            formik.touched.is_faskes_malaria_medicine_service
          }
          errorMessage={formik.errors.is_faskes_malaria_medicine_service}
          isRequired={true}
        />

        <div className="maps-input">
          <label htmlFor="" style={{ marginBottom: "12px", fontWeight: "600" }}>
            Pilih Lokasi
          </label>
          <MapsComponents
            coordinate={formik.values.coordinate}
            onChangeLocation={(address, coordinate) => {
              handleMapChange(address, coordinate);
            }}
          />
        </div>
        <InputField
          name={"coordinate"}
          placeholder={"Titik koordinat akan muncul disini"}
          value={formik.values.coordinate}
          readOnly={true}
        />

        <div className="form_action">
          <Button
            variant={"tertiary"}
            size={"normal"}
            onClick={() => changeMode(PageMode.view)}
          >
            Batalkan
          </Button>
          <Button
            variant={"primary"}
            size={"normal"}
            onClick={formik.handleSubmit}
            isDisabled={
              formik.isSubmitting ||
              !formik.values.year ||
              !formik.values.bkk_id ||
              !formik.values.is_faskes_malaria_service ||
              !formik.values.is_faskes_malaria_medicine_service
            }
          >
            Simpan Data
          </Button>
        </div>
      </div>
    </>
  );
};

export default FormComponent;
